import React, { FC } from "react";
import { Card, CardContent, CardHeader, Container, Divider, Grid, Paper, Typography, MenuItem } from "@mui/material";
import Stack from "@mui/material/Stack";
import { useTranslation } from "react-i18next";
import store from "./store"
import { observer } from "mobx-react";
import CustomTextField from "components/TextField";
import InfoIcon from "@mui/icons-material/Info";

type organization_settingTableProps = {
  children?: React.ReactNode;
  isPopup?: boolean;
};

const Organization_settingAddEditBaseView: FC<organization_settingTableProps> = observer((props) => {
  const { t } = useTranslation();
  const translate = t;
  
  return (
    <Container maxWidth='xl' sx={{ mt: 3 }}>
      <Grid container spacing={3}>
        <Grid item md={props.isPopup ? 12 : 6}>
          <form data-testid="organization_settingForm" id="organization_settingForm" autoComplete='off'>
            <Card component={Paper} elevation={5}>
              <CardHeader title={
                <span id="organization_setting_TitleName">
                  {translate('label:organization_settingAddEditView.entityTitle')}
                </span>
              } />
              <Divider />
              <CardContent>
                <Grid container spacing={3}>

                  <Grid item md={12} xs={12}>
                    <CustomTextField
                      value={store.setting_key}
                      onChange={(event) => store.handleChange(event)}
                      name="setting_key"
                      data-testid="id_f_organization_setting_key"
                      id='id_f_organization_setting_key'
                      label={translate('label:organization_settingAddEditView.setting_key')}
                      helperText={store.errors.setting_key}
                      error={!!store.errors.setting_key}
                      InputProps={{
                        required: true
                      }}
                    />
                  </Grid>

                  <Grid item md={12} xs={12}>
                    <CustomTextField
                      value={store.setting_value}
                      onChange={(event) => store.handleChange(event)}
                      name="setting_value"
                      data-testid="id_f_organization_setting_value"
                      id='id_f_organization_setting_value'
                      label={translate('label:organization_settingAddEditView.setting_value')}
                      helperText={store.errors.setting_value}
                      error={!!store.errors.setting_value}
                      multiline={store.data_type === 'json'}
                      rows={store.data_type === 'json' ? 4 : 1}
                      InputProps={{
                        required: true
                      }}
                    />
                  </Grid>

                  <Grid item md={12} xs={12}>
                    <CustomTextField
                      value={store.description}
                      onChange={(event) => store.handleChange(event)}
                      name="description"
                      data-testid="id_f_organization_setting_description"
                      id='id_f_organization_setting_description'
                      label={translate('label:organization_settingAddEditView.description')}
                      helperText={store.errors.description}
                      error={!!store.errors.description}
                      multiline
                      rows={3}
                    />
                  </Grid>

                  {store.data_type && (
                    <Grid item md={12} xs={12}>
                      <Stack direction="row" alignItems="center" gap={1}>
                        <InfoIcon color="info" />
                        <Typography variant="body2" color="text.secondary">
                          {translate(`label:organization_settingAddEditView.data_type_hint.${store.data_type}`)}
                        </Typography>
                      </Stack>
                    </Grid>
                  )}

                </Grid>
              </CardContent>
            </Card>
          </form>
        </Grid>
        {props.children}
      </Grid>
    </Container>
  );
})

export default Organization_settingAddEditBaseView;